export default __webpack_public_path__ + "static/media/paymentMore.232cd14e.png";